export class BulkSelectSnapshotsForResourcesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "_from",
            "baseName": "from",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "pick",
            "baseName": "pick",
            "type": "SnapshotRangePick",
            "format": ""
        },
        {
            "name": "isClean",
            "baseName": "isClean",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkSelectSnapshotsForResourcesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
